export default "__VITE_ASSET__eJNmcQ96__"